import React from "react";
import { inject } from "mobx-react";
import { Upload, message } from "antd";
import TerraUploader from "@dji/terra-uploader";

import agent from "../../../agent";
import { $util } from "../../../helper";

import Language from "../../language/language";
import KvItem from "./kvItem";

import "../stylesheets/uploadSchoolBadge.scss";
import classNames from "classnames";

@inject("languageStore")
class UploadSchoolBadge extends React.Component {
  state = {
    // 校徽url
    imageUrl: this.props.value || "",
    // 校徽文件类型
    type: "",
    // 校徽文件大小
    large: "",
    // 校徽文件尺寸
    width: "",
    height: "",
    // 校徽文件类型是否满足要求
    typeChecked: false,
    // 校徽大小是否满足要求
    largeChecked: false,
    // 校徽尺寸是否满足要求
    sizeChecked: false,
    // 是否加载完成（请求校徽是否完成）
    isReady: false
  };

  componentDidMount() {
    if (this.state.imageUrl) {
      this.getImageUrlInfo();
    } else {
      this.props.onReady && this.props.onReady();
    }
  }

  judgeImage = () => {
    const { type, large, width, height } = this.state;
    this.setState(
      {
        // 校徽文件类型是否满足要求
        typeChecked: this.checkType(type),
        // 校徽大小是否满足要求
        largeChecked: this.checkLarge(large),
        // 校徽尺寸是否满足要求
        sizeChecked: this.checkSize(width, height)
      },
      this.afterUploadFileSuc
    );
  };

  getImageUrlInfo = () => {
    const imageUrl = this.state.imageUrl;
    const badgeUrl = $util.getCdnUrl(imageUrl);
    fetch(badgeUrl)
      .then(res => {
        return res.blob();
      })
      .then(resBlob => {
        const imageUrl = URL.createObjectURL(resBlob);
        const imgObj = new Image();

        imgObj.onload = () => {
          const type = resBlob.type ? resBlob.type.split("/")[1] : "";
          const large = resBlob.size ? (resBlob.size / 1024 / 1024).toFixed(2) : 0;
          this.setState(
            {
              width: imgObj.width,
              height: imgObj.height,
              type,
              large: large,
              isReady: true
            },
            this.judgeImage
          );
        };

        imgObj.src = imageUrl;
      })
      .catch(err => {
        console.error(err);
        message.error(
          this.props.languageStore.getResource(
            this.props.languageStore.lang,
            "SCHOOL_BADGE_FETCH_ERROR"
          )
        );
      })
      .finally(() => {
        this.props.onReady && this.props.onReady();
      });
  };

  afterUploadFileSuc = () => {
    const { imageUrl, typeChecked, largeChecked, sizeChecked } = this.state;
    if (this.props.onChange) {
      this.props.onChange({
        imageUrl,
        typeChecked,
        largeChecked,
        sizeChecked
      });
    }
  };

  uploadFile = (file, type, size) => {
    agent.Common.getV2UploadSts({
      bucket_type: "public"
    })
      .then(res => {
        if (res.status === 0) {
          const config = res.result;
          const terraOptions = {
            config: config,
            onSuccess: () => {
              const imageUrl = `https://${config.cloudBucketName}.${config.endPoint}/${config.objectKey}`;
              this.setState(
                {
                  type: type,
                  imageUrl: imageUrl,
                  large: size,
                  width: 800,
                  height: 800
                },
                this.judgeImage
              );
            },
            onError: () => {
              message.error(
                this.props.languageStore.getResource(
                  this.props.languageStore.lang,
                  "CREATE_TEAM_LOGO_TIP_ERROR"
                )
              );
            }
          };
          const uploader = new TerraUploader(file, terraOptions);
          uploader.start();
        }
      })
      .catch(err => {
        message.error(
          this.props.languageStore.getResource(
            this.props.languageStore.lang,
            "CREATE_TEAM_LOGO_TIP_ERROR"
          )
        );
      });
  };

  checkType = type => type.includes("png");

  checkLarge = large => large <= 1;

  checkSize = (width, height) => width === 800 && height === 800;

  handleBeforeUpload = file => {
    const lang = this.props.languageStore.lang;
    const size = (file.size / 1024 / 1024).toFixed(2);
    if (!this.checkType(file.type)) {
      message.error(this.props.languageStore.getResource(lang, "CREATE_TEAM_LOGO_TIP_TYPE"));
      return false;
    }
    if (!this.checkLarge(size)) {
      message.error(this.props.languageStore.getResource(lang, "CREATE_TEAM_LOGO_TIP_LARGE"));
      return false;
    }
    $util.getImgSize(file).then(res => {
      if (res.width && res.height && this.checkSize(res.width, res.height)) {
        this.uploadFile(file, file.type, size);
      } else {
        message.error(
          this.props.languageStore.getResource(
            this.props.languageStore.lang,
            "CREATE_TEAM_LOGO_TIP_SIZE"
          )
        );
      }
    });
    return false;
  };

  render() {
    const {
      imageUrl,
      type,
      large,
      width,
      height,
      typeChecked,
      largeChecked,
      sizeChecked
    } = this.state;

    return (
      <div className="uploadSchoolBadge">
        <div className="uploadSchoolBadge__uploadBox">
          <Upload
            className="uploadSchoolBadge__uploadBox--upload"
            listType="picture-card"
            showUploadList={false}
            beforeUpload={this.handleBeforeUpload}
          >
            {imageUrl ? (
              <img src={imageUrl} alt="avatar" style={{ width: "100%" }} />
            ) : (
              <Language className="uploadSchoolBadge__tips" resource="CLICK_TO_SELECT_FILE" />
            )}
          </Upload>
          <div className="uploadSchoolBadge__imgInfo">
            <KvItem
              className={classNames(
                "uploadSchoolBadge__imgInfo--box",
                !typeChecked && "uploadSchoolBadge__imgInfo--box-wrong"
              )}
              vskey="SCHOOL_BADGE_FORMATS"
              value={type || "-"}
            />
            <KvItem
              className={classNames(
                "uploadSchoolBadge__imgInfo--box",
                !largeChecked && "uploadSchoolBadge__imgInfo--box-wrong"
              )}
              vskey="SCHOOL_BADGE_LARGE"
              value={large ? `${large}MB` : "-"}
            />
            <KvItem
              className={classNames(
                "uploadSchoolBadge__imgInfo--box",
                !sizeChecked && "uploadSchoolBadge__imgInfo--box-wrong"
              )}
              vskey="SCHOOL_BADGE_SIZE"
              value={width && height ? `${width}px * ${height}px` : "-"}
            />
          </div>
        </div>
        <Language className="uploadSchoolBadge__tips" resource="UPLOAD_SCHOOL_BADGE_TIPS" />
      </div>
    );
  }
}

export default UploadSchoolBadge;



// WEBPACK FOOTER //
// ./src/components/common/teamInfo/uploadSchoolBadge.js